module.exports = __webpack_public_path__ + "img/wheelbarrow_front.45be1b1a.png";